import { useEffect } from "react";

type TPreloadOptions = {
  delay?: number;
};
export const usePreloadModules = (
  modules: {
    preload: () => Promise<any>;
  }[],
  options: TPreloadOptions = {
    delay: 100,
  },
) => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      modules.forEach((module) => {
        module.preload();
      });
    }, options.delay);
    return () => clearTimeout(timeout);
  }, modules);
};
